class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      let item = this.dataset.index;
      if(!event.currentTarget.classList.contains('disabled')){
        let remove_popup_mask = document.querySelector('.delete-product-popup-mask');
        let remove_popup = document.querySelector('.delete-product-popup');
        remove_popup.querySelector('.delete-confirm').setAttribute('data-item', item);
        remove_popup_mask.classList.add('active');
        remove_popup.classList.add('active');
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartEditButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.editItem(event);
    });
  }
}

customElements.define('cart-item__edit-btn', CartEditButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    let pathName = decodeURIComponent(window.location.href);
    if (pathName.indexOf("?") !== -1 && pathName.indexOf("recovery_customer_email") !== -1) {
      let customer_email = pathName.split("recovery_customer_email=")[1];
      customer_email = customer_email.split("&")[0];
      this.mergeItems(customer_email);
    }else{
      this.init();
    }
  }
  init(){
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.initElements();
    this.checkoutSubmit();
  }
  cartUpdateUnsubscriber = undefined;
  mergeItems(customer_email){
    let $this = this;
    this.showProgress();
    fetch(`/apps/app-proxy/api/keep-cart-by-email/` + customer_email,
      {method: 'GET'})
      .then(response => response.json())
      .then(cart => {
        let persistent_cart = cart;
        if(persistent_cart.data){
          let persistent_cart_items = [];
          let changed_cart_items = {};
          let persistent_cart_item;
          let same_persistent_item = Object.values(persistent_cart.data.reduce((c, v) => {
            let k = v.variant_id;
            c[k] = c[k] || [];
            c[k].push(v);
            return c;
          }, {})).reduce((c, v) => v.length > 1 ? c.concat(v) : c, []);

          persistent_cart.data.forEach((item, i) => {

            let persistent_item_q = persistent_cart.variants_inventory_data[i].quantity;
            let persistent_item_inv_policy = persistent_cart.variants_inventory_data[i].inventory_policy;
            let persistent_item_inv_management = persistent_cart.variants_inventory_data[i].inventory_management;
            let same_products = document.querySelectorAll('.cart-item[data-id="'+ item.variant_id +'"]');
            let all_quantity = 0;
            let current_item_quantity = 0;
            if(persistent_cart_items.find(added_item => added_item.variant_id == item.variant_id)){
              persistent_cart_items.forEach((added_item) => {
                if(added_item.variant_id == item.variant_id){
                  all_quantity += +added_item.quantity;
                }
              });
            }

            if(same_products.length > 0){
              same_products.forEach((same_item) => {
                all_quantity += +same_item.querySelector('.quantity__input').value;
              });
            }
            if(persistent_item_inv_policy == "deny" && persistent_item_inv_management == "shopify"){
              if(all_quantity > persistent_item_q){
                current_item_quantity = (persistent_item_q - all_quantity) > 0 ? (persistent_item_q - all_quantity) - item.quantity >= 0 ? item.quantity : persistent_item_q - all_quantity : 0;
              }else {
                current_item_quantity = item.quantity;
              }
            }else {
              current_item_quantity = item.quantity;
            }
            if(persistent_item_q > 0 || persistent_item_q <= 0 && persistent_item_inv_management != "shopify"){

              if(item.properties['_product_info_custom_id'] && !document.querySelector('.cart-item[data-custome-id="'+ item.properties['_product_info_custom_id'] +'"]') || !item.properties && !document.querySelector('.cart-item[data-id="'+ item.variant_id +'"]')){

                if(current_item_quantity > 0){
                  persistent_cart_item = {
                    quantity: current_item_quantity,
                    id: item.variant_id,
                    properties: item.properties
                  }
                  persistent_cart_items.push(persistent_cart_item);
                }
              }else if(item.properties['_product_info_custom_id'] && document.querySelector('.cart-item[data-custome-id="'+ item.properties['_product_info_custom_id'] +'"]')){
                let item_prop = document.querySelector('.cart-item[data-custome-id="'+ item.properties['_product_info_custom_id'] +'"]').getAttribute('data-full-prop');
                let line_item_key = document.querySelector('.cart-item[data-custome-id="'+ item.properties['_product_info_custom_id'] +'"]').getAttribute('data-item-key');
                let changed_prop = false;
                item_prop.split('`,`').forEach((element) => {
                  if(!item.properties.hasOwnProperty(element.split('`:`')[0]) || !(item.properties[element.split('`:`')[0]] == element.split('`:`')[1])){
                    changed_prop = true;
                  }
                });
                if(changed_prop){
                  changed_cart_items[line_item_key] = 0;
                  persistent_cart_items.push(
                    {
                      quantity: current_item_quantity,
                      id: item.variant_id,
                      properties: item.properties
                    }
                  );
                }
              }
            }

          });

          if(Object.keys(changed_cart_items).length > 0){
            let body = JSON.stringify({updates: changed_cart_items});
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                $this.changeCartItems(persistent_cart_items);
              })
              .catch(e => {
                $this.hideProgress();
                $this.init();
              });
          }else if(persistent_cart_items.length > 0){
            $this.changeCartItems(persistent_cart_items);
          }else{
            $this.hideProgress();
            $this.init();
          }
        }else{
          $this.hideProgress();
          $this.init();
        }
      });

  }
  initElements() {
    this.cartItems = this.querySelectorAll('.cart-item');
    if(customer_id){
      this.createMeasurements();
    }
    this.detailsBtn = this.querySelectorAll('.cart-item__details-btn');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.measurementLaterBtn = this.querySelectorAll('.measurement-later-btn');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.copyItemBtn = this.querySelectorAll('.cart-item__copy');
    Currency.convertAll(theme.settings.defaultShopCurrency, getCookie("currentCurrency"));
    this.changePrice();
    this.initEvents();
  }
  initEvents() {
    this.detailsBtn.forEach((btn) =>
      btn.addEventListener('click', this.showDeatails.bind(this))
    );

    this.measurementLaterBtn.forEach((btn) =>
      btn.addEventListener('click', this.chooseMeasureLater.bind(this))
    );
    this.copyItemBtn.forEach((btn) =>
      btn.addEventListener('click', this.copyItem.bind(this))
    );
    this.cartItems.forEach((item) => {
      this.checkTotalQuantity(item);
    });
  }
  createMeasurements(){
    let profiles;
    if(measurement_profiles){
      profiles = measurement_profiles.customerMeasurementProfiles;
    }else{
      let measurement_profiles_cookie = localStorage.getItem("measurement-profiles");
      profiles = JSON.parse(measurement_profiles_cookie).customerMeasurementProfiles;
    }
    this.cartItems.forEach((item) => {
      let productType = item.getAttribute('data-product-type');
      let measure_select_option = '';
      let measure_custom_select_options = '';
      let show_profiles = false;
      let edit_measure_btn = '';
      if(item.querySelector('.customer-measurement-profiles')){
        let ms_id = item.querySelector('.customer-measurement-profiles').getAttribute('data-measurement-id');
        if(profiles.length > 0){
          let contains_profile = false;
          let line = item.getAttribute('id').split('-')[1];
          profiles.forEach((profile) => {
            if(profile.measurementProductType == productType){
              show_profiles = true;
              let pf_values = [];
              profile.values.forEach((pf_value) => {
                pf_values.push({"name": pf_value.measurement.name , "value" : pf_value.value });
              });
              measure_select_option += `<option
             data-ms-values='${JSON.stringify(pf_values).replace(/'/g,"&prime;")}'
             data-ms-id='${profile.id}'
             data-ms-role='${profile.measurementTypeRole}'
             ${profile.id == ms_id ? 'selected' : ''}
            >${profile.name}</option>`;
              measure_custom_select_options +=`<div class="select-items_value ${profile.id == ms_id ? 'selected' : ''}" data-ms-id='${profile.id}'>${profile.name}</div>`
              if(profile.id == ms_id ){
                item.querySelector('.cart-item__measurement').classList.add('selected');
                item.querySelector('.custom-select .popup-btn').innerHTML = profile.name;
                item.querySelector('.item__measurement-main-btn').classList.add('selected');
                let edit_btn
                if(profile.measurementTypeRole == 'preset'){
                  edit_btn = item.querySelector('.item__measurement-edit-wrap .edit-preset-profile');
                }else{
                  edit_btn = item.querySelector('.item__measurement-edit-wrap .edit-profile');
                }
                edit_btn.setAttribute('role', profile.measurementTypeRole);
                edit_btn.setAttribute('data-measure-id', profile.id);
                edit_btn.classList.add('active');
                this.checkMeasurements(ms_id, productType, pf_values, profile.measurementTypeRole, line);
                contains_profile = true;
              }
            }
          });
          if(ms_id == 'submit_later'){
            contains_profile = true;
            item.querySelector('.custom-select .popup-btn').innerHTML = document.querySelector('.translators .submit-later').innerHTML;
            item.querySelector('.item__measurement-main-btn').classList.add('selected');
            item.querySelector('.cart-item__measurement').classList.add('selected');
            this.checkCheckoutBtn();
          }
          if(measure_select_option != ''){
            item.querySelector('.ms-profile').innerHTML += measure_select_option;
          }
          if(measure_custom_select_options != ''){
            item.querySelector('.select-items').innerHTML += measure_custom_select_options;
          }
        }else{
          if(ms_id == 'submit_later'){
            item.querySelector('.cart-item__measurement').classList.add('selected');
            this.checkCheckoutBtn();
          }
        }
        if(show_profiles){
          item.querySelector('.customer-measurement-profiles').classList.remove('hidden');
        }else{
          item.querySelector('.customer-measurement-without-profiles').classList.remove('hidden');
        }
      }
    });

    this.itemsValue = this.querySelectorAll('.select-items_value:not([disabled])');
    this.msProfile = this.querySelectorAll('.ms-profile');

    this.itemsValue.forEach(option => option.addEventListener("click", this.changeSelect.bind(this)));
    this.msProfile.forEach(profile => profile.addEventListener("change", this.chooseProfile.bind(this)));

    this.cartItems.forEach((item) => {
      let pathName = decodeURIComponent(window.location.href);
      if (pathName.indexOf("?") !== -1 && pathName.indexOf("ms_id") !== -1) {
        let params = pathName.split("?")[1];
        let pathNames = params.split('&');
        let line_id;
        let ms_id;
        pathNames.forEach(pathName => {
          if(pathName.indexOf('line') > -1){
            line_id = pathName.split('=')[1];
          }
          if(pathName.indexOf('ms_id') > -1){
            ms_id = pathName.split('=')[1];
          }
        });
        if(item.getAttribute('data-custome-id') == line_id){
          if(item.querySelector('.select-items_value[data-ms-id="'+ ms_id +'"]')){
            item.querySelector('.select-items_value[data-ms-id="'+ ms_id +'"]').dispatchEvent(new Event('click'));
            window.history.pushState(null, null, pathName.split("?")[0]);
          }
        }
      }
    });
  }
  showDeatails(event) {
    event.preventDefault();
    event.currentTarget.parentElement.classList.toggle('active-popup');
  }
  copyItem(ev) {
    ev.preventDefault();
    this.showProgress();
    const elem = ev.currentTarget;
    let cur_item = this.findAncestor(elem , 'cart-item');
    let line_id = cur_item.getAttribute('data-id');
    let item_prop = cur_item.getAttribute('data-prop');
    let propObj = {};
    let line = cur_item.getAttribute('id').split('-')[1];
    item_prop.split('`,`').forEach((element) => {
      if(element.split('`:`')[0] != '_total_additional_price'){
        propObj[element.split('`:`')[0]] = element.split('`:`')[1];
      }
      if(element.split('`:`')[0] == '_options_additional_price'){
        propObj['_total_additional_price'] = element.split('`:`')[1];
      }
    });
    propObj['_product_info_custom_id'] = Date.now();
    propObj['_measurements_additional_price'] = 0;
    const body = JSON.stringify({
      id: line_id,
      properties: propObj,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.checkTotalQuantity(cur_item);
        this.checkCheckoutBtn();
        if(customer_id){
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cur_cart => {
              let cart_items = JSON.stringify({cart: cur_cart.items});
              fetch(`/apps/app-proxy/api/keep-cart/` + customer_id,
                {
                  method: 'POST',
                  body: cart_items
                })
                .then(response => response.json())
                .then(response => {
                  this.initElements();
                  this.hideProgress();
                });
            });
        }else{
          this.initElements();
          this.hideProgress();
        }

      })
      .catch((e) => {
        console.error(e);
        this.hideProgress();
      })
  }
  chooseMeasureLater(ev){
    ev.preventDefault();
    ev.stopPropagation();
    let $this = this;
    this.showProgress();
    const elem = ev.currentTarget;
    let cur_item = this.findAncestor(elem , 'cart-item');
    let line = cur_item.getAttribute('id').split('-')[1];
    let show_err = false;
    if(this.querySelectorAll('.measure_error.active').length > 0){
      show_err = true;
    };
    let item_prop = cur_item.getAttribute('data-prop');
    let quantity = cur_item.querySelector('.quantity__input').value;
    let propObj = {};
    item_prop.split('`,`').forEach((element) => {
      propObj[element.split('`:`')[0]] = element.split('`:`')[1];
    });
    propObj["_ms-id"] = 'submit_later';
    propObj['_measurements_additional_price'] = 0;
    propObj['_total_additional_price'] = propObj['_options_additional_price'];
    const body = JSON.stringify({
      line,
      quantity,
      properties: propObj,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if(!parsedState.errors){
          elem.classList.toggle('active');
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          const lineItem =  document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          lineItem.querySelector('.measurement-later-btn').classList.add('active');
          lineItem.querySelector('.cart-item__measurement').classList.add('selected');
          if(show_err && document.querySelectorAll('.cart-item__measurement:not(.selected):not(.without-measure)').length != 0){
            document.querySelectorAll('.cart-item__measurement:not(.selected):not(.without-measure)').forEach((error) => {
              error.querySelectorAll('.measure_error').forEach((error) => error.classList.add('active'));
            });
          }
          if(customer_id){
            fetch(window.Shopify.routes.root + 'cart.js')
              .then(response => response.json())
              .then(cur_cart => {
                let cart_items = JSON.stringify({cart: cur_cart.items});
                fetch(`/apps/app-proxy/api/keep-cart/` + customer_id,
                  {
                    method: 'POST',
                    body: cart_items
                  })
                  .then(response => response.json())
                  .then(response => {
                    $this.checkCheckoutBtn();
                    $this.initElements();
                    $this.hideProgress();
                  });
              });
          }else{
            $this.checkCheckoutBtn();
            $this.initElements();
            $this.hideProgress();
          }


        }else {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.querySelector('.cart__blocks #cart-errors').innerHTML = parsedState.errors;
          this.hideProgress();
        }

      });
  }
  chooseProfile(ev){
    ev.preventDefault();
    ev.stopPropagation();
    if(document.querySelector('.page-loading-overlay')){
      this.showProgress();
    }
    const elem = ev.currentTarget;
    let cur_item = this.findAncestor(elem , 'cart-item');
    let line = cur_item.getAttribute('id').split('-')[1];
    let show_err = false;
    if(this.querySelectorAll('.measure_error.active').length > 0){
      show_err = true;
    };
    let ms_id = elem.options[elem.selectedIndex].getAttribute('data-ms-id');
    let item_prop = cur_item.getAttribute('data-prop');
    let ms_rules = JSON.parse(document.getElementById('measure-rules').innerHTML);
    let productType = cur_item.getAttribute('data-product-type');
    let values = elem.options[elem.selectedIndex].getAttribute('data-ms-values');
    let role = elem.options[elem.selectedIndex].getAttribute('data-ms-role');
    let quantity = cur_item.querySelector('.quantity__input').value;
    let propObj = {};
    let measurements_additional_price = 0;
    let options_additional_price = 0;
    item_prop.split('`,`').forEach((element) => {
      propObj[element.split('`:`')[0]] = element.split('`:`')[1];
      if( element.split('`:`')[0] == '_options_additional_price'){
        options_additional_price = +element.split('`:`')[1]
      }
    });
    propObj["_ms-id"] = ms_id;
    if(propObj["_ms-id"] != 'submit_later'){
      JSON.parse(values).forEach((element) => {
        propObj['_ms_name_' + element.name] = element.value;
        propObj[element.name] = element.value;
      });
      ms_rules.forEach(rule => {
        let obj;
        if(rule.productType == productType && rule.role == role){
          JSON.parse(values).forEach(value => {
            rule.measurements.forEach(measure => {
              if(value.name == measure.name){
                obj = value;
                if(obj && measure.required && obj.value != '' && obj.value != 'null' && obj.value != null){
                  if(measure.priceRules){
                    measure.priceRules.forEach(priceRule => {
                      if(obj.value >= priceRule.from && obj.value <= priceRule.to){
                        measurements_additional_price += priceRule.price;
                        propObj['_ms_name_' + value.name] = value.value + ` ($${priceRule.price})`;
                        propObj[value.name] = value.value + ` ($${priceRule.price})`;
                      }
                    });
                  }
                }
              }
            });
          });
        }
      });
    }
    propObj['_measurements_additional_price'] = measurements_additional_price;
    propObj['_total_additional_price'] = options_additional_price + measurements_additional_price;
    const body = JSON.stringify({
      line,
      quantity,
      properties: propObj,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (!parsedState.errors) {
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
          this.initElements();
          const lineItem =  document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          let measure_variant = lineItem.querySelector('option[data-ms-id="'+ ms_id +'"]');
          let title = measure_variant.innerText;
          let parent = lineItem.querySelector('.item__btn_select');
          lineItem.querySelector('.cart-item__measurement').classList.add('selected');
          lineItem.querySelector('.custom-select span').innerHTML = title;
          parent.querySelector('select').value = title;
          if(ms_id != 'submit_later'){
            //lineItem.querySelector('.item__measurement-edit').classList.add('active');
          }
          if(show_err && document.querySelectorAll('.cart-item__measurement:not(.selected):not(.without-measure)').length != 0){
            document.querySelectorAll('.cart-item__measurement:not(.selected):not(.without-measure)').forEach((error) => {
              error.querySelectorAll('.measure_error').forEach((error) => error.classList.add('active'));
            });
          }
          if(customer_id){
            let cart_items = JSON.stringify({cart: parsedState.items});
            fetch(`/apps/app-proxy/api/keep-cart/` + customer_id,
              {
                method: 'POST',
                body: cart_items
              })
              .then(response => response.json())
              .then(response => {
                this.checkCheckoutBtn();
                if(document.querySelector('.page-loading-overlay')){
                  this.hideProgress();
                }
              });
          }else{
            this.checkCheckoutBtn();
            if(document.querySelector('.page-loading-overlay')){
              this.hideProgress();
            }
          }
        }else {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('cart-errors').innerHTML = parsedState.errors;
          this.hideProgress();
        }

      });

  }
  changeSelect(e){
    e.preventDefault();
    e.stopPropagation();
    let title = e.currentTarget.textContent || e.currentTarget.innerText;
    let parent = this.findAncestor(e.currentTarget.parentElement , 'item__btn_select');
    e.currentTarget.parentElement.previousElementSibling.querySelector('span').innerHTML = title;
    parent.querySelector('select').value = title;
    parent.classList.remove('active');
    parent.classList.add('selected');
    parent.querySelector('select').dispatchEvent(new Event('change'));
  }
  checkCheckoutBtn(){
    if(document.querySelectorAll('.cart-item__measurement:not(.selected):not(.without-measure)').length == 0 && document.querySelectorAll('.measure_rule_error.active').length == 0){
      document.querySelector('.custom-checkout').classList.remove('disabled');
      //document.querySelector('.custom-checkout-wrap .cart__dynamic-checkout-buttons').classList.remove('hidden');
    }else{
      document.querySelector('.custom-checkout').classList.add('disabled');
      //document.querySelector('.custom-checkout-wrap .cart__dynamic-checkout-buttons').classList.add('hidden');
    }
    this.checkoutSubmit();
  }
  checkTotalQuantity(cur_item){
    let product_q = cur_item.getAttribute('data_quantity');
    let product_inv_policy = cur_item.getAttribute('data_inventory_policy');
    let product_inv_management = cur_item.getAttribute('data_inventory_management');
    let product_variant_id = cur_item.getAttribute('data-id');
    let same_products = document.querySelectorAll('.cart-item[data-id="'+ product_variant_id +'"]');
    let all_quantity = 0;
    same_products.forEach((item) => {
      all_quantity += +item.querySelector('.quantity__input').value;
    });
    if(all_quantity >= +product_q && product_inv_policy == "deny" && product_inv_management == "shopify"){
      same_products.forEach((item) => {
        item.querySelector('.quantity__input').setAttribute('max', item.querySelector('.quantity__input').value);
        if(item.querySelector('.cart-item__copy')){
          item.querySelector('.cart-item__copy').classList.add('hidden');
        }
      });
    }
  }
  changePrice(){
    let current_cur = getCookie("currentCurrency");
    if(current_cur){
      let items = this.querySelectorAll('.cart-items .cart-item');
      let cart_total_price = parseFloat(document.querySelector('.totals .price-with-custom-currency').getAttribute('data-currency-'+ current_cur.toLowerCase()).match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0].replace(/[^0-9]/g, ""));
      let u = Currency.money_format[current_cur];
      let line_price;
      items.forEach((item) =>{
        let new_price = 0;
        if(item.querySelector('.cart-item__discounted-prices')){
          line_price = parseFloat(item.querySelector('.cart-item__totals .cart-item__old-price.price .cart-item-line-price').getAttribute('data-currency-'+ current_cur.toLowerCase()).match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0].replace(/[^0-9]/g, ""));
          let line_price_discounted = parseFloat(item.querySelector('.cart-item__totals .price:not(.cart-item__old-price) .cart-item-line-price').getAttribute('data-currency-'+ current_cur.toLowerCase()).match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0].replace(/[^0-9]/g, ""));
          let total_price = Currency.convert(line_price, current_cur, current_cur) * 100;
          let total_discounted_price = Currency.convert(line_price_discounted, current_cur, current_cur) * 100;
          let total_price_format = Currency.formatMoney(total_price, u);
          let total_discounted_price_format = Currency.formatMoney(total_discounted_price, u);
          item.querySelectorAll('.cart-item__totals .cart-item__old-price.price .cart-item-line-price').forEach(el=> el.innerHTML = total_price_format);
          item.querySelectorAll('.cart-item__totals .price:not(.cart-item__old-price) .cart-item-line-price').forEach(el=> el.innerHTML = total_discounted_price_format);
        }else{
          line_price = parseFloat(item.querySelector('.cart-item__totals .cart-item-line-price').getAttribute('data-currency-'+ current_cur.toLowerCase()).match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0].replace(/[^0-9]/g, ""));
          let total_price = Currency.convert(line_price, current_cur, current_cur) * 100;
          let total_price_format = Currency.formatMoney(total_price, u);
          item.querySelectorAll('.cart-item__totals .cart-item-line-price').forEach(el=> el.innerHTML = total_price_format);
        }
      });
      let cart_total_price_format = Currency.formatMoney((Currency.convert(cart_total_price, current_cur, current_cur) * 100), u);
      document.querySelectorAll('.totals .price-with-custom-currency').forEach(el=> el.innerHTML = cart_total_price_format);
    }

  };
  checkoutSubmit(){
    let $this = this;
    if(document.querySelector('.cart__footer .custom-checkout')){
      document.querySelector('.cart__footer .custom-checkout').addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        let cart_items = document.querySelectorAll('.cart-item');
        let correct_cart = false;
        let correct_item_count = 0;
        cart_items.forEach((item, i) => {
          let item_prop = item.getAttribute('data-full-prop');
          if(item_prop.length > 0 && item_prop.indexOf('_options') > -1 && item_prop.indexOf('_options_additional_price') > -1 || item_prop.length == 0 || item_prop.indexOf('_options') == -1){
            correct_item_count += 1;
          }else{
            item.querySelector('.prop_error').classList.add('active');
          }
        });
        if(correct_item_count == cart_items.length){
          correct_cart = true;
        }
        if(correct_cart){
          if(event.currentTarget.classList.contains('disabled') && !document.querySelector('#cart-errors').innerHTML){
            let items_measure = document.querySelectorAll('.cart-item__measurement:not(.selected):not(.without-measure)');
            if(items_measure){
              items_measure.forEach((item, i) => {
                item.querySelectorAll('.measure_error').forEach((error) => error.classList.add('active'));
                function offset(el) {
                  var rect = el.getBoundingClientRect(),
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                  return { top: rect.top + scrollTop }
                }
                var divOffset = offset(item.parentElement);
                if (i == 0) {
                  window.scrollTo({ top: divOffset.top, behavior: 'smooth' });
                }
              });
            }
          }else{
            let btn = event.currentTarget;
            btn.classList.add('loading');
            btn.setAttribute('aria-disabled', true);
            let customer_id = btn.getAttribute('data-customer-id');
            let body;
            fetch('/cart.json').then(cart => cart.json()).then(cart => {
              if(customer_id != ''){
                body = {
                  "line_items": cart.items,
                  "customer": {id: customer_id}
                }
              }else{
                body = {
                  "line_items": cart.items
                }
              }
              if(cart.token){
                body['token'] = cart.token;
              }
              fetch(`/apps/app-proxy/create-draft`, {body: JSON.stringify(body), method: 'POST'}).then(response => response.json()).then(response => {});
              document.querySelector('.custom-checkout').classList.remove('loading');
              window.location.href = '/checkout';
            })
          }
        }
      });
    }
  }
  checkMeasurements(ms_id, productType, values, role, line){
    let ms_rules = JSON.parse(document.getElementById('measure-rules').innerHTML);
    let additional_price = false;
    ms_rules.forEach(rule => {
      let obj;
      if(rule.productType == productType && rule.role == role){
        rule.measurements.forEach(measure => {
          values.forEach(value => {
            if(value.name == measure.name){
              obj = value;
            }
          });
          if(obj && measure.required && obj.value != '' && obj.value != 'null' && obj.value != null){
            if(measure.priceRules){
              measure.priceRules.forEach(priceRule => {
                if(obj.value >= priceRule.from && obj.value <= priceRule.to){
                  additional_price = true;
                  const lineItem =  document.getElementById(`CartItem-${line}`);
                  let additional_price_div = '<div class="product-option">\n' +
                    '+<span class="price-with-custom-currency" data-price="' + priceRule.price +'">$'+ priceRule.price +'</span>\n' +
                    '                                    <div> ('+ obj.name + '' + obj.value +') </div>\n' +
                    '                                  </div>'
                  if(lineItem.querySelector('.cart-item__details-content')){
                    lineItem.querySelector('.cart-item__details-content').innerHTML += additional_price_div;
                  }
                }
              });
            }
          }
        });
      }
    });
    if(document.querySelector('.custom-checkout')){
      this.checkCheckoutBtn();
    }
  }
  editItem(ev){
    ev.preventDefault();
    ev.stopPropagation();
    let param = ev.currentTarget.querySelector('.cart-item__change-btn').getAttribute('data-item-edit');
    let url = ev.currentTarget.querySelector('.cart-item__change-btn').getAttribute('href');
    let item_id = ev.currentTarget.querySelector('.cart-item__change-btn').getAttribute('data-item-edit-id');
    localStorage.setItem('custom_edit_' + item_id, param);
    if(url.indexOf('?')){
      window.location.href = url + '&edit_id=' + item_id;
    }else{
      window.location.href = url + '?edit_id=' + item_id;
    }

  }
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cart__blocks',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    let eventTarget;
    if(event == 'clear'){
      eventTarget = 'clear';
    }else{
      eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    }


    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });
        if (cartFooter) this.checkCheckoutBtn();
        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        if(customer_id){
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cur_cart => {
              let cart_items = JSON.stringify({cart: cur_cart.items});
              fetch(`/apps/app-proxy/api/keep-cart/` + customer_id,
                {
                  method: 'POST',
                  body: cart_items
                })
                .then(response => response.json())
                .then(response => {
                  this.tagName.toLowerCase() == 'cart-drawer-items' ? document.querySelector('cart-drawer').initElements() : this.initElements();
                  this.disableLoading();
                });
            });
        }else{
          this.tagName.toLowerCase() == 'cart-drawer-items' ? document.querySelector('cart-drawer').initElements() : this.initElements();
          this.disableLoading();
        }
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  showProgress(){
    document.querySelector('.page-loading-overlay').style.display = 'block';
    document.querySelector('.page-loading-overlay').classList.add('active');
    document.querySelector('.custom-checkout').classList.add('loading');
  }
  hideProgress(){
    document.querySelector('.page-loading-overlay').style.display = 'none';
    document.querySelector('.page-loading-overlay').classList.remove('active');
    document.querySelector('.custom-checkout').classList.remove('loading');
  }
  findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

window.addEventListener('DOMContentLoaded', () => {

  if(document.querySelector('cart-items')){
    customer_id = document.querySelector('cart-items').getAttribute('data-customer-id');
    if(customer_id){
      let measurement_profiles_cookie = localStorage.getItem("measurement-profiles");
      let measurement_types_cookie = localStorage.getItem("measurement-types");
      let profiles_url = '/apps/app-proxy/api/measurement-profiles/';
      let measurement_url = '/apps/app-proxy/api/measurement-types/';
      let profiles_local_date;
      let profiles_update_date = 0;
      let measurement_local_date;
      let measurement_update_date = 0;

      if(measurement_profiles_cookie ){
        profiles_local_date = JSON.parse(measurement_profiles_cookie)["date-created"];
        profiles_update_date = new Date(theme.settings.profiles_date).getTime();
      }
      if( measurement_types_cookie){
        measurement_local_date = JSON.parse(measurement_types_cookie)["date-created"];
        measurement_update_date = new Date(theme.settings.measurements_date).getTime();
      }
      if (!measurement_profiles_cookie && !measurement_types_cookie || measurement_profiles_cookie == null && measurement_types_cookie == null || profiles_update_date > profiles_local_date && measurement_update_date > measurement_local_date
        || !measurement_profiles_cookie &&  measurement_update_date > measurement_local_date || !measurement_types_cookie && profiles_update_date > profiles_local_date || measurement_update_date > measurement_local_date) {
        let storage_date = new Date();
        localStorage.removeItem("measurement-profiles");
        localStorage.removeItem("measurement-types");
        Promise.all([
          fetch(profiles_url + customer_id , {method: 'GET'}).then((response) => response.json())
            .then((responseJSON) => {
              if (responseJSON.success) {
                measurement_profiles = responseJSON;
              }
            }),
          fetch(measurement_url + customer_id, {method: 'GET'}).then((response) => response.json())
            .then((responseJSON) => {
              if (responseJSON.success) {
                measurement_types = responseJSON;
              }
            })
        ]).then(responses => {
          customElements.define('cart-items', CartItems);
          customElements.define('cart-measurements', measurementsContent);
        });
      }else if( profiles_update_date > profiles_local_date || !measurement_profiles_cookie)  {
        let storage_date = new Date();
        localStorage.removeItem("measurement-profiles");
        fetch(profiles_url + customer_id , {method: 'GET'}).then((response) => response.json())
          .then((responseJSON) => {
            if (responseJSON.success) {
              measurement_profiles = responseJSON;
              customElements.define('cart-items', CartItems);
              customElements.define('cart-measurements', measurementsContent);
            }
          })
      }else if(!measurement_types_cookie)  {
        let storage_date = new Date();
        localStorage.removeItem("measurement-types");
        fetch(measurement_url + customer_id, {method: 'GET'}).then((response) => response.json())
          .then((responseJSON) => {
            if (responseJSON.success) {
              measurement_types = responseJSON;
              customElements.define('cart-items', CartItems);
              customElements.define('cart-measurements', measurementsContent);
            }
          })
      }else{
        customElements.define('cart-items', CartItems);
        customElements.define('cart-measurements', measurementsContent);
      }

      let measure_popup_close = document.querySelectorAll('.measure-profile-popup-close');
      let changed_yes = document.querySelector('.form-changed-yes');
      let changed_no = document.querySelector('.form-changed-no');

      measure_popup_close.forEach(btn => btn.addEventListener('click', (event) => {
        if(formChanged){
          document.querySelector('.form-changed-mask').classList.add('active');
          document.querySelector('.form-changed-popup').classList.add('active');
        }else{
          document.querySelector('.measure-popup-mask').classList.remove('active');
          let bodyScrollY = parseInt(document.body.style.getPropertyValue('top'), 10);
          bodyScrollY = Math.abs(bodyScrollY);
          document.body.classList.remove("fixed");
          document.body.style.top = null;
          window.scrollTo(0, bodyScrollY);
          btn.parentElement.classList.remove('active');
        }

      }));
      if(changed_no){
        changed_no.addEventListener('click', (event) => {
          event.preventDefault();
          document.querySelector('.form-changed-mask').classList.remove('active');
          var btn_block = event.currentTarget.parentElement;
          btn_block.parentElement.classList.remove('active');
        });
      }
      if(changed_yes){
        changed_yes.addEventListener('click', (event) => {
          event.preventDefault();
          document.querySelector('.measure-popup-mask').classList.remove('active');
          let bodyScrollY = parseInt(document.body.style.getPropertyValue('top'), 10);
          bodyScrollY = Math.abs(bodyScrollY);
          document.body.classList.remove("fixed");
          document.body.style.top = null;
          window.scrollTo(0, bodyScrollY);
          document.querySelector('.form-changed-mask').classList.remove('active');
          document.querySelector('.form-changed-popup').classList.remove('active');
          document.querySelector('.measure-profile-popup.active').classList.remove('active');
          formChanged = false;
        });
      }
    }else{
      customElements.define('cart-items', CartItems);
    }
  }

  let remove_popup_mask = document.querySelector('.delete-product-popup-mask');
  let remove_popup = document.querySelector('.delete-product-popup');
  let reject_btn = remove_popup.querySelector('.delete-reject');
  let confirm_btn = remove_popup.querySelector('.delete-confirm');
  reject_btn.addEventListener('click', (event) => closePopup());
  confirm_btn.addEventListener('click', (event) => {
    let item = confirm_btn.getAttribute('data-item');
    closePopup();
    let cartItems;
    if(document.querySelector('.cart-page')){
      cartItems = document.querySelector('cart-items');
    }else{
      cartItems = document.querySelector('cart-drawer-items');
    }
    cartItems.updateQuantity(item, 0,'clear');
  });

  function closePopup(){
    remove_popup_mask.classList.remove('active');
    remove_popup.classList.remove('active');
  }

});
window.addEventListener('mouseup', e => {
  let option_popups = document.querySelectorAll(".cart-item__details-content");
  if(option_popups){
    option_popups.forEach(popup => {
      if(popup && popup.parentElement.classList.contains('active-popup')){
        if (e.target != popup && e.target != popup.parentElement && e.target != popup.closest('.popup-container').querySelector('.item-popup-btn') && !e.target.closest('.cart-item__details-btn-icons') ) {
          popup.parentElement.classList.remove('active-popup');
        }
      }
    });
  }

  let measure_popups = document.querySelectorAll(".select-items");
  if(measure_popups){
    measure_popups.forEach(popup => {
      if(popup && popup.parentElement.classList.contains('active')){
        if (e.target != popup && e.target != popup.parentElement && e.target != popup.closest('.popup-container').querySelector('svg') && e.target != popup.closest('.popup-container').querySelector('.item-popup-btn') && !e.target.classList.contains('popup-btn')) {
          popup.parentElement.classList.remove('active');
        }
      }
    });
  }
});


